/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextHighlightIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Highlight',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18.55762,2.95215l-1.50977-1.50977c-.8623-.8623-2.22266-.92969-3.1582-.1543l-6.84766,5.58105c-.30664.25781-.54297.59082-.68652.96582l-.65088,1.71387c-.00024,0-.00024.00024-.00024.00024l-.00513.01343c-.04395.11426-.10938.21582-.19531.30176l-1.44141,1.44141c-.54102.54102-.66577,1.34131-.37988,2.00586l-2.4082,2.4082c-.21484.21484-.27832.53711-.16309.81738.11621.28027.38965.46289.69336.46289h3.90137c.19922,0,.38965-.0791.53027-.21973l.45947-.45898c.22754.09644.46948.14746.7124.14746.46582,0,.93164-.17676,1.28613-.53125l1.44141-1.44141c.08594-.08594.1875-.15137.2998-.19434l1.73047-.65723c.37402-.14355.70703-.37988.97168-.69531l5.57129-6.83496c.77637-.94043.71094-2.2998-.15137-3.16211ZM7.63379,14.87695c-.125.125-.32617.12305-.45117,0l-2.05859-2.05859c-.125-.125-.125-.32812-.00098-.45215l1.37549-1.37549,2.51074,2.51074-1.37549,1.37549ZM17.5498,5.16309l-5.56738,6.83008c-.09375.11133-.21484.19727-.35059.24902l-1.27588.48486-3.08301-3.08301.48486-1.2749c.05176-.13672.1377-.25781.24023-.34473l6.84277-5.57715c.15918-.13086.35156-.19531.54297-.19531.21875,0,.43652.08398.60352.25098l1.50977,1.50977c.3125.3125.33691.80566.05273,1.15039Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
